import { getState } from '~src/state';

const STORAGE_KEY_PREFIX = 'giotto:provino:export-settings';

const getOrgId = () => {
  try {
    return getState('user.org_pointer.objectId') ?? null;
  } catch (err) {
    return null;
  }
};

const getCanvasFormatId = () => {
  try {
    const format = getState('selected.formato');
    const formatDefault = getState('selected.formatoDefault');
    const defaultFormatId =
      formatDefault?.objectId ||
      format?.editor_project_formats_default_pointer?.objectId;

    if (defaultFormatId) {
      return `default:${defaultFormatId}`;
    }

    if (format?.objectId) {
      return `custom:${format.objectId}`;
    }

    return null;
  } catch (err) {
    return null;
  }
};

const getStorageKey = (orgId, canvasFormatId) =>
  `${STORAGE_KEY_PREFIX}:${orgId}:${canvasFormatId}`;

export const saveExportSettings = (settings) => {
  const orgId = getOrgId();
  const canvasFormatId = getCanvasFormatId();
  if (!orgId || !canvasFormatId) {
    return;
  }
  try {
    localStorage.setItem(
      getStorageKey(orgId, canvasFormatId),
      JSON.stringify(settings)
    );
  } catch (err) {
    console.error('Failed to save provino export settings', err);
  }
};

export const loadExportSettings = () => {
  const orgId = getOrgId();
  const canvasFormatId = getCanvasFormatId();
  if (!orgId || !canvasFormatId) {
    return null;
  }
  try {
    const raw = localStorage.getItem(getStorageKey(orgId, canvasFormatId));
    return raw ? JSON.parse(raw) : null;
  } catch (err) {
    console.error('Failed to load provino export settings', err);
    return null;
  }
};
